import script from "./HistoryUser.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryUser.vue?vue&type=script&setup=true&lang=js"

import "./HistoryUser.vue?vue&type=style&index=0&id=068300d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-068300d2"]])

export default __exports__